// Centralized token storage utilities
export const TOKEN_STORAGE_KEY = 'catena_link_token';

export const tokenStorage = {
  get: (): string | null => {
    try {
      return localStorage.getItem(TOKEN_STORAGE_KEY);
    } catch (error) {
      console.error('[tokenStorage] Error reading from localStorage:', error);
      return null;
    }
  },

  set: (token: string): void => {
    try {
      localStorage.setItem(TOKEN_STORAGE_KEY, token);
    } catch (error) {
      console.error('[tokenStorage] Error writing to localStorage:', error);
    }
  },

  remove: (): void => {
    try {
      localStorage.removeItem(TOKEN_STORAGE_KEY);
    } catch (error) {
      console.error('[tokenStorage] Error removing from localStorage:', error);
    }
  },

  clear: (): void => {
    try {
      localStorage.removeItem(TOKEN_STORAGE_KEY);
    } catch (error) {
      console.error('[tokenStorage] Error clearing from localStorage:', error);
    }
  },
};
